<template lang="pug">
div
  validation-provider.hidden(slim :rules="{required: addon.required && !disabled}" :vid="`addon_${addon.id}`" v-slot="{errors}" )
    input(type="checkbox" v-model="undestroyed" :set="file_errors=errors")
  ul.inner-list.with_indentation
    li.checkbox-field2(v-for="(choice, idx) in addon.choices")
      label(:for="addon_idx+'-choice_'+idx")
        .content
          .row
            .columns.large-18
              .checkbox-holder(v-if="should_render_addon_form({registration: registration, program: registration.program})")
                  .choice_input(v-if="addon.multiple_choices || addon.automatically_applied")
                      input.no-custom(
                          v-model="registration_addon.choice_ids",
                          :value="choice.id"
                          type="checkbox",
                          :id="addon_idx+'-choice_'+idx",
                          :disabled="disabled || (addon.automatically_applied && current_organization.isBlank())",
                          @change="makeDelete"
                      )
                      span.label-text
                  .choice_input(v-else)
                      input.no-custom(
                          type="radio"
                          :value="choice.id"
                          :checked="registration_addon.choice_ids[0] === choice.id"
                          @click="radioClick(choice.id)",
                          :id="addon_idx+'-choice_'+idx",
                          :disabled="disabled || addon.automatically_applied",
                          :required="required",
                      )
                      span.label-text
              .label-text(:class="{error: file_errors[0]}")
                strong {{choice.name}}

            // ONLY for addons that have choice type ==custom. Meaning they can enter the price they want to pay. Usually for donations.
            .columns.large-6
              .choice_type(v-if="addon.pricing_type === 'fixed' && choice.choice_type === 'custom'")
                .price.other_amount_field.field(v-if="registration_addon.choice_ids.includes(choice.id)")
                   //- - registration_addon.other_amount ||= OpenStruct.new
                   //- =addon_fields.fields_for :other_amount, OpenStruct.new(registration_addon.other_amount) do |other_amount|
                   //-  = other_amount.text_field( :"#{choice.id}",{ data: {min: 0, behaviour: :currency, a_sign:'$', choice_type: choice.choice_type}, placeholder:'Enter $ Amount', class: 'other_amount_field', readonly: disabled})
                   validation-provider(:rules="{required: true}" name="amount" v-slot="{ errors }")
                     vue-autonumeric(
                      :options="['dollar', { minimumValue: '0' }]"
                      v-model="registration_addon.other_amount[choice.id]"
                      placeholder="Enter $ Amount"
                      :disabled="disabled"
                      :class="{error: errors[0]}"
                    )
              .choice_type(v-else)
                .price {{ number_to_currency(choice.amount, addon.currency) }}
</template>

<script>
import helpers from 'templates/registrations/helper'
import VueAutonumeric from 'components/VueAutonumeric.vue';
import {ValidTodayAbility} from "models/concerns/valid_today_ability"
export default{
  mixins: [helpers],
  props: ["registration_addon","addon_idx", "disable_block_for_family"],
  components: {VueAutonumeric},
  data (){
    return {
      org_edit: false,
      file_errors: [],          // to make errors global
    }
  },
  mounted(){
    if (this.addon.automatically_applied && this.ability.valid_today()){
      for (let choice of this.addon.choices){
        if(this.registration_addon.choice_ids.includes(choice.id)) continue;
        this.registration_addon.choice_ids.push(choice.id)
      }
    }
    this.registration_addon.other_amount || (this.registration_addon.other_amount={})
    this.makeDelete()
  },
  methods:{
    // we need to make possible to uncheck value
    radioClick(id) {
      if (this.registration_addon.choice_ids[0] === id) this.registration_addon.choice_ids=[]
      else this.registration_addon.choice_ids = [id]
      this.makeDelete()
    },
    makeDelete(){
      this.$set(this.registration_addon, "_destroy", this.registration_addon.choice_ids.length === 0)
    },
  },
  computed: {
    addon(){
      return this.registration_addon.addon
    },
    ability(){
      return new ValidTodayAbility(this.addon._attributes)
    },
    registration(){
      return this.state.current_reg
    },
    validate(){
      return this.registration.isStillPending()
    },
    disabled(){
      let val = this.registration.disable_reg_block(this.state.current_org)
      if (this.registration.preview && this.addon.automatically_applied) val = true
      return val
    },
    required(){
      return this.addon.required && this.editing_as_a_family
    },
    undestroyed(){
      return this.registration_addon._destroy ? null : true // null here is essential
    },
  }
}
</script>
